import type { ComputedRef, Ref } from 'vue';
import { computed } from 'vue';

import type { IChangeHistoryEntry } from '@modules/change-history/components/VChangeHistory/types';
import { useDeleteHistoryOfAdminFeesMutation } from '@modules/admin-fees/mutations';
import { useHistoryOfAdminFeesQuery } from '@modules/admin-fees/queries';

export interface IHistoryOfAdminFeesComposable {
  historyOfAdminFeesChanges: ComputedRef<IChangeHistoryEntry[]>;
  isHistoryLoading: Ref<boolean>;
  onHistoryDelete(entry: IChangeHistoryEntry): Promise<void>;
}

export default function useHistoryOfAdminFees(): IHistoryOfAdminFeesComposable {
  const { data: historyList, isLoading: isHistoryLoading, setData } = useHistoryOfAdminFeesQuery();
  const { mutateAsync: deleteHistory } = useDeleteHistoryOfAdminFeesMutation();

  const historyOfAdminFeesChanges = computed(() => historyList.value?.history_of_admin_fees_changes ?? []);

  async function onHistoryDelete(entry: IChangeHistoryEntry): Promise<void> {
    try {
      await deleteHistory(entry.id);
      updateHistoryList(historyOfAdminFeesChanges.value.filter(({ id }) => id !== entry.id));
    } catch {}
  }

  function updateHistoryList(list?: IChangeHistoryEntry[]): void {
    setData((queryData) => {
      if (!queryData) {
        return queryData;
      }

      return {
        ...queryData,
        history_of_admin_fees_changes: list ?? queryData.history_of_admin_fees_changes,
      };
    });
  }

  return {
    historyOfAdminFeesChanges,
    isHistoryLoading,
    onHistoryDelete,
  };
}
